/* Lossless, bounded dictionary compression for public collection markup. */
(function () {
  'use strict';
  window.WFSCollectionCache = {
    pack: function (text) {
      var bytes = new TextEncoder().encode(text), dictionary = new Map();
      var codes = [], next = 257, word = bytes[0];
      if (!bytes.length) return {codec: 'lzw1', size: 0, data: ''};
      for (var i = 1; i < bytes.length; i++) {
        var byte = bytes[i], key = word * 256 + byte, match = dictionary.get(key);
        if (match !== undefined) { word = match; continue; }
        codes.push(word);
        if (next < 65535) dictionary.set(key, next++);
        else { codes.push(256); dictionary.clear(); next = 257; }
        word = byte;
      }
      codes.push(word);
      var packed = new Uint8Array(codes.length * 2), chunks = [];
      for (var j = 0; j < codes.length; j++) {
        packed[j * 2] = codes[j] & 255;
        packed[j * 2 + 1] = codes[j] >> 8;
      }
      for (var offset = 0; offset < packed.length; offset += 16384) {
        chunks.push(String.fromCharCode.apply(null, packed.subarray(offset, offset + 16384)));
      }
      return {codec: 'lzw1', size: bytes.length, data: btoa(chunks.join(''))};
    },
    unpack: function (packed) {
      if (typeof packed === 'string') return packed;
      if (!packed || packed.codec !== 'lzw1' || packed.size > 24000000 || packed.size < 0) throw Error('Invalid collection cache');
      var binary = atob(packed.data), output = new Uint8Array(packed.size);
      var prefixes = new Uint16Array(65536), suffixes = new Uint8Array(65536), stack = new Uint8Array(65536);
      var next = 257, previous = -1, first = 0, written = 0;
      function expand(code) {
        var length = 0;
        while (code >= 257) {
          if (code >= next || length >= stack.length) throw Error('Invalid collection dictionary');
          stack[length++] = suffixes[code]; code = prefixes[code];
        }
        if (code > 255) throw Error('Invalid collection code');
        stack[length++] = code;
        first = code;
        while (length) {
          if (written >= output.length) throw Error('Invalid collection length');
          output[written++] = stack[--length];
        }
      }
      for (var i = 0; i < binary.length; i += 2) {
        var code = binary.charCodeAt(i) | (binary.charCodeAt(i + 1) << 8);
        if (code === 256) { next = 257; previous = -1; continue; }
        if (previous === -1) { expand(code); previous = code; continue; }
        if (code === next) {
          expand(previous);
          if (written >= output.length) throw Error('Invalid collection length');
          output[written++] = first;
        } else expand(code);
        if (next < 65535) { prefixes[next] = previous; suffixes[next++] = first; }
        previous = code;
      }
      if (written !== output.length) throw Error('Incomplete collection cache');
      return new TextDecoder().decode(output);
    }
  };
})();
